const getTabStyle = (color: string) => {
  return {
    root: {
      borderBottom: 1,
      borderColor: 'divider',
      display: 'inline-block',
      width: '100%',
      background: '#fff',
    },
    tabs: {
      '& .MuiTab-root.Mui-selected': {
        color: color,
      },
      '& .MuiTabs-indicator': {
        backgroundColor: color,
      },
    },
    tab: {
      textTransform: 'capitalize',
      fontSize: '16px',
      fontWeight: 500,
      minWidth: '60px',
    },
  };
};

export default getTabStyle;
